import React from 'react'
import { Paper, InputBase, IconButton } from '@material-ui/core'
import { Search } from '@material-ui/icons'

import classes from './CustomSearchComponent.module.scss'

export default function CustomSearchComponent(props) {
  const { name, onChange, placeholder, width } = props

  return (
    <Paper style={width ? { width: width } : {}} className={classes.root}>
      <IconButton className={classes.iconButton} aria-label='search'>
        <Search fontSize='12' />
      </IconButton>
      <InputBase
        className={classes.input}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search google maps' }}
        onChange={e => {
          onChange(e)
        }}
        autoComplete='no'
        name={name}
      >
      </InputBase>
    </Paper>
  )
}
